<div class="row">
  <div class="col align-self-center">

    <div class="shadow p-3 mb-4 bg-white rounded">    
      <div class="row p-2" style="margin-bottom: -8px; margin-top: -8px;">
        <div class="col-md-5"></div>
        <div class="col-md-3">
          <p style="font-size: 14px;" *ngIf="isFilter" >Filter / Compare by Store:</p> <ng-select *ngIf="isFilter" placeholder="Select Store" [items]="storeIdArray" bindLabel="dba" bindValue="id" (change)="getSelectedStore($event)" labelForId="StoreLbl" notFoundText="No store found" [(ngModel)]="selStore" [multiple]="true" #ngSelectComponent> </ng-select>
        </div>
        <div class="col-md-3">
          <p style="font-size: 14px;">Filter by TPN:</p> 
          <ng-select placeholder="Select TPN" [items]="tpnIdArray" bindLabel="tpn" bindValue="tpn" (change)="getSelectedTPN($event)" labelForId="TPNLbl" notFoundText="No tpn found" [(ngModel)]="selTPN" #ngSelectComponent> 
            <ng-template ng-option-tmp let-item="item"> <div style="font-size: 16px;">{{item.tpn}} <br/> {{item.defaultLabel}}</div> </ng-template>
          </ng-select>
        </div>
        <div class="col-md-1 mt-3 text-right">          
          <button type="button" (click)="refreshComponent()" triggers="mouseenter:mouseleave" ngbPopover="Refresh" class="btn btn-outline-primary btn-circle" title="Refresh"><i class="link-icon feather icon-refresh-cw"></i></button>
        </div>
      </div>
    </div>

    <div class="card-Head" >
      <h5>Transactions Volume & Count</h5>
    </div>

    <div [ngClass]="isMobileView ? '' : 'row custom-column'" >
      <app-card [Volume]="todayVolume +'/'" [Count]="todayCount" [TimePeriod]="TimePeriodtoday"
        [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto" [isShow] = false
        [loaderId]="'loader-10'"
        [cardColor]="'bgColor1'"  [text]="'custom-text-size-transaction'"[btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'" [label]="'Transaction Volume'">
      </app-card>
    
      <app-card [Volume]="currentMonthVolume +'/'" [Count]="currentMonthCount"
        [TimePeriod]="TimePeriodThismonth" [List]="'List'" [List]="'List'"
        class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
        (modelOpenTransactionVolume)="openModalWidget9(modalWidget10,'loader-11','transaction')" [isShow] = false
        (modelOpenTransactionCount)="openModalWidget6(modalWidget6,'loader-11')" [loaderId]="'loader-11'" [cardColor]="'bgColor1'"
        [text]="'custom-text-size-transaction'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'" [label]="'Transaction Volume'">
      </app-card>
    
      <ng-template #modalWidget10 let-modal>
        <app-card-modal-widget [modalTitle]="thisMonthTransactionTitle" [loaderId]="'loader-0909'" [isChartShow]="isChartShow"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isCardShow]="false" [isGeoLocation]="false" [isShowSalesPerson]="false" [isShowprocessor]="false" [isShowMode]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChart9Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget90('loader-0909','transaction')" (deviceType)="openWidget91('transaction')" (viewByChannel)="openWidget93('transaction')">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #modalWidget6 let-modal>
        <app-card-modal-widget [modalTitle]="'Processing Count - This Month'" [loaderId]="'loader-0606'" [isShowprocessor]="false" [isShowSalesPerson]="false"  [isShowDevice] ="true" [isCardShow]="false" [isShowprocessor]="false"[isShowMode]="false"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false"
          [apexChartSPCustomers]="apexChart6Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget60('loader-0606')" (deviceType)="openWidget61()" 
          (viewByChannel)="openWidget63()">
        </app-card-modal-widget>
      </ng-template>
    
      <app-card [Volume]="lastMonthVolume +'/'" [Count]="lastMonthCount"
        [TimePeriod]="TimePeriodLastmoth" [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
        (modelOpenTransactionVolume)="openModalWidget8(modalWidget11,'loader-12','transaction')" [isShow] = false
        (modelOpenTransactionCount)="openModalWidget5(modalWidget5,'loader-12')" [loaderId]="'loader-12'" [cardColor]="'bgColor1'"
        [text]="'custom-text-size-transaction'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'">
      </app-card>
    
      <ng-template #modalWidget11 let-modal>
        <app-card-modal-widget [modalTitle]="lastMonthTransactionTitle" [loaderId]="'loader-0808'" [isChartShow]="isChartShow" [isShowDevice] ="true"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false" [isCardShow]="false" [isShowSalesPerson]="false" [isShowprocessor]="false" [isShowMode]="false"
          [apexChartSPCustomers]="apexChart8Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget80('loader-0808','transaction')" (deviceType)="openWidget81('transaction')" (viewByChannel)="openWidget83('transaction')">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #modalWidget5 let-modal>
        <app-card-modal-widget [modalTitle]="'Processing Count - Last Month'" [loaderId]="'loader-0505'" [isShowprocessor]="false" [isShowSalesPerson]="false"  [isShowDevice] ="true" [isCardShow]="false" [isShowprocessor]="false"[isShowMode]="false"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false"
          [apexChartSPCustomers]="apexChart5Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget50('loader-0505')" (deviceType)="openWidget51()" 
          (viewByChannel)="openWidget53()" >
        </app-card-modal-widget>
      </ng-template>
    
      <app-card [Volume]="last3MonthVolume +'/' + ' '" [Count]="last3MonthCount" [TimePeriod]="'Last 3 Months'"
        [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}" [isShow] = false
        (modelOpenTransactionVolume)="openModalWidget7(modalWidget12,'loader-13','transaction')"
        (modelOpenTransactionCount)="openModalWidget4(modalWidget4,'loader-13')" [loaderId]="'loader-13'" [cardColor]="'bgColor1'"
        [text]="'custom-text-size-transaction'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'" [label]="'Transaction Volume'">
      </app-card>
    
      <ng-template #modalWidget12 let-modal>
        <app-card-modal-widget [modalTitle]="totalTransactionTitle" [loaderId]="'loader-0707'" [isChartShow]="isChartShow"
          [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true"  [isGeoLocation]="false" [isCardShow]="false" [isShowSalesPerson]="false" [isShowprocessor]="false" [isShowMode]="false" [isShowDevice] ="true"
          [apexChartSPCustomers]="apexChart7Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="last3MonthsTransaction('loader-0707','transaction')" (deviceType)="openWidget71('transaction')" (viewByChannel)="openWidget73('transaction')">
        </app-card-modal-widget>
      </ng-template>
    
      <ng-template #modalWidget4 let-modal>
        <app-card-modal-widget [modalTitle]="'Processing Count - 12 Months'" [loaderId]="'loader-0404'" [isShowprocessor]="false" [isShowSalesPerson]="false"  [isShowDevice] ="true" [isCardShow]="false" [isShowprocessor]="false"[isShowMode]="false"
          [isChartShow]="isChartShow" [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false"
          [apexChartSPCustomers]="apexChart4Options" (closeModal)="modal.close('by: close icon')"
          (viewBySummary)="openWidget40('loader-0404')" (deviceType)="openWidget41()" (viewByChannel)="openWidget43()" >
        </app-card-modal-widget>
      </ng-template>
    
    </div>

    <div class="card-Head">
      <h5>Settled Batches - Transactions</h5>
    </div>    

    <div [ngClass]="isMobileView ? '' : 'row custom-column'">
      <app-card [Volume]="todayTransactionsVolume " [TimePeriod]="TimePeriodtoday"
      [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto"
      (navigateClicked)="navigateToTransaction({date:'today'}, todayTransactionsVolume)" [loaderId]="'loader-14'"
      [cardColor]="'bgColor2'" [cardButton]="'card-button2'" [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'"[label]="'Transaction Volume'" >
    </app-card>
  
    <app-card [Volume]="currentMonthTransactionsVolume"
      [TimePeriod]="TimePeriodThismonth" [List]="'List'" [List]="'List'"
      class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
      (navigateClicked)="navigateToTransaction({date:'current'}, currentMonthTransactionsVolume)"
      (modelOpenTransactionVolume)="openModalWidget9(modalWidget9,'loader-09','settleBatch')"
      [loaderId]="'loader-09'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
      [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'"[label]="'Transaction Volume'">
    </app-card>
  
    <ng-template #modalWidget9 let-modal>
      <app-card-modal-widget [modalTitle]="thisMonthTransactionTitle" [loaderId]="'loader-0909'" [isChartShow]="isChartShow"
        [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isCardShow]="false" [isGeoLocation]="false" [isShowSalesPerson]="false" [isShowprocessor]="false" [isShowMode]="false" [isShowDevice] ="true"
        [apexChartSPCustomers]="apexChart9Options" (closeModal)="modal.close('by: close icon')"
        (viewBySummary)="openWidget90('loader-0909','settleBatch')" (deviceType)="openWidget91('settleBatch')" (viewByChannel)="openWidget93('settleBatch')">
      </app-card-modal-widget>
    </ng-template>

  
    <app-card [Volume]="lastMonthTransactionsVolume"
      [TimePeriod]="TimePeriodLastmoth" [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
      (navigateClicked)="navigateToTransaction({date:'last'}, lastMonthTransactionsVolume)"
      (modelOpenTransactionVolume)="openModalWidget8(modalWidget8,'loader-08')"
       [loaderId]="'loader-08'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
       [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'"[label]="'Transaction Volume'">
    </app-card>
  
    <ng-template #modalWidget8 let-modal>
      <app-card-modal-widget [modalTitle]="lastMonthTransactionTitle" [loaderId]="'loader-0808'" [isChartShow]="isChartShow" [isShowDevice] ="true"
        [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true" [isGeoLocation]="false" [isCardShow]="false" [isShowSalesPerson]="false" [isShowprocessor]="false" [isShowMode]="false"
        [apexChartSPCustomers]="apexChart8Options" (closeModal)="modal.close('by: close icon')"
        (viewBySummary)="openWidget80('loader-0808','settleBatch')" (deviceType)="openWidget81('settleBatch')" (viewByChannel)="openWidget83('settleBatch')">
      </app-card-modal-widget>
    </ng-template>
  
   <app-card [Volume]="last3MonthTransactionsVolume" [TimePeriod]="'Last 3 Months'"
      [List]="'List'" class="col-md-3 grid-margin stretch-card mx-auto" [ngStyle]="{'pointer-events': isLoading ? 'none' : 'initial'}"
      (navigateClicked)="navigateToTransaction({date:'threeMonth'}, last3MonthTransactionsVolume)"
      (modelOpenTransactionVolume)="openModalWidget7(modalWidget7,'loader-07','settleBatch')"
      [loaderId]="'loader-07'" [cardColor]="'bgColor2'" [cardButton]="'card-button2'"
      [text]="'customerText'" [count]="'customer-count'" [btnLabel]="'Transaction List'" [countlabel]="'Transaction Count'"[label]="'Transaction Volume'">
    </app-card>
  
    <ng-template #modalWidget7 let-modal>
      <app-card-modal-widget [modalTitle]="totalTransactionTitle" [loaderId]="'loader-0707'" [isChartShow]="isChartShow"
        [isShowLabel]="isShowLabel" [isShowLabeltransaction]="true"  [isGeoLocation]="false" [isCardShow]="false" [isShowSalesPerson]="false" [isShowprocessor]="false" [isShowMode]="false" [isShowDevice] ="true"
        [apexChartSPCustomers]="apexChart7Options" (closeModal)="modal.close('by: close icon')"
        (viewBySummary)="openWidget70('loader-0707','settleBatch')" (deviceType)="openWidget71('settleBatch')" (viewByChannel)="openWidget73('settleBatch')">
      </app-card-modal-widget>
    </ng-template>
  
    </div>    

    <div class="row">

      <div class="col-md-3">
        <p style="font-size: 16px;">Date Range:</p> <ng-select placeholder="Filter by Date Range" [items]="rangeIdArray" bindLabel="rangeLabel" bindValue="range" (change)="getSelectedRange($event)" labelForId="RangeLbl" notFoundText="No Range found" [(ngModel)]="selRange" [clearable]="false" #ngSelectComponent> </ng-select>
      </div>
      
      <div class="col-md-12"><br></div>
      
      <div class="col-md-12 grid-margin stretch-card" *ngIf="CBChartShow == true">
        <div class="card hover-remove bg-c-white shadow-lg rounded" style="padding: unset;">  
          <p>
            <apx-chart [series]="apexChartCBOptions.series" [chart]="apexChartCBOptions.chart" [markers]="apexChartCBOptions.markers"
                [dataLabels]="apexChartCBOptions.dataLabels" [plotOptions]="apexChartCBOptions.plotOptions" [yaxis]="apexChartCBOptions.yaxis"
                [responsive]="apexChartCBOptions.responsive" [xaxis]="apexChartCBOptions.xaxis" [labels]="apexChartCBOptions.labels"
                [legend]="apexChartCBOptions.legend" [fill]="apexChartCBOptions.fill" [title]="apexChartCBOptions.title" [annotations]="apexChartCBOptions.annotations"
                [colors]="apexChartCBOptions.colors" [grid]="apexChartCBOptions.grid" [tooltip]="apexChartCBOptions.tooltip" [stroke]="apexChartCBOptions.stroke"></apx-chart>
          </p>
          <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
            [loaderId]="'loader-15'" [bgsPosition]="'center-center'">
          </ngx-ui-loader>
        </div>
      </div>       
      
      <div class="col-md-12 pb-4 " *ngIf="CBChartShow == false">
        <div class="box box5" style="text-align:center">
            <h4>No settled batch transactions found...</h4>
            <ngx-ui-loader [bgsColor]="'red'" [fgsColor]="'red'" [pbColor]="'red'" [bgsOpacity]="1"
            [loaderId]="'loader-15'" [bgsPosition]="'center-center'">
          </ngx-ui-loader>
        </div>
      </div>

      <!-- small boxes -->
      <div class="col-md-12">
        <div class="px-0" [ngClass]="isMobileView ? '' : 'row custom-column'">
          <div class="col-md-3 pb-4" (click)="show = !show">
            <div class="box box1">
              <h4>{{overallClosedBatchTotal}}</h4>
              <div class="d-flex justify-content-between">
                <p class="custom-text-size">Total Sale Amount</p>
                <i class="icon-lg text-muted pb-6px" data-feather="arrow-down-circle" appFeatherIcon></i>
              </div>
            </div>
          </div>
          <div class="col-md-3 pb-4">
            <div class="box box1">
              <h4>{{averageClosedBatchTicketSize}}</h4>
              <p class="custom-text-size">Average Batch Size</p>
            </div>
          </div>
          <div class="col-md-3 pb-4">
            <div class="box box1">
              <h4>{{averageClosedBatch}}</h4>
              <p class="custom-text-size">Average Daily Sale</p>
            </div>
          </div>
          <div class="col-md-3 pb-4">
            <div class="box box1">
              <h4>{{transactionAvgTicketSize}}</h4>
              <p class="custom-text-size">Average Ticket Size</p>
            </div>
          </div>
        </div>
      </div>
      <!-- small boxes end -->

      <!-- small boxes - 3 -->
      <div class="col-md-12"  *ngIf="show">
        <div class="px-0" [ngClass]="isMobileView ? '' : 'row custom-column'">
          <div class="col-md-3 pb-4">
            <div class="boxCB ">
                <h4>{{overallCBBaseAmount}}</h4>
                <p class="custom-text-size">Base Sale Amount</p>
            </div>
          </div>      
          <div class="col-md-3 pb-4">
            <div class="boxCB">
                <h4>{{overallCBTipAmount}}</h4>
                <p>Tip Amount</p>
            </div>
          </div>
          <div class="col-md-3 pb-4">
            <div class="boxCB">
                <h4>{{overallCBFeeAmount}}</h4>
                <p class="custom-text-size">Fee Amount</p>
            </div>
          </div> 
          <div class="col-md-3 pb-4">
            <div class="boxCB">
                <h4>{{overallCBTaxAmount}}</h4>
                <p class="custom-text-size">Tax Amount</p>
            </div>
          </div>    
        </div>   
      </div>   
      <!-- small boxes -3 end -->

    </div>      
  </div>
</div>